import {
 SchoolIcon,
 ArticleIcon,
 UserIcon,
 QueryStatsIcon,
 EventIcon,
 InterestsIcon
} from "./Icons";
export const SIDEBAR_DATA = [
 {
   id: 1,
   name: "\\about me",
   path: "",
   icon: <UserIcon />,
   },
   {
   id: 2,
   name: "\\research",
   path: "research",
   icon: <QueryStatsIcon />,
   },
   {
   id: 3,
   name: "\\conferences",
   path: "conferences",
   icon: <EventIcon />,
   },
   {
   id: 4,
   name: "\\teaching + service",
   path: "teachingservice",
   icon: <SchoolIcon />,
   },
   {
   id: 5,
   name: "\\extracurriculars",
   path: "extracurriculars",
   icon: <InterestsIcon />,
   }
];